// extracted by mini-css-extract-plugin
module.exports = {"dropdown__menu":"_bC","dropdown":"_bD","dropdown__trigger":"_bE","dropdown__icon":"_bF"};